export default "__VITE_ASSET__BxyOCSPf__"